module.exports = __webpack_public_path__ + "img/logo-dark-sm.png";